const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Træf dit valg her",
  seeAll: "Se alle",
  clear: "Ryd",
  back: "Tilbage",
  save: "Gem",
  close: "Luk",
  of: "Af",
  to: "til",
  copyrights: "© {date} Bridgestone. Alle rettigheder forbeholdes.",
  pageNotFound: "Siden blev ikke fundet",
  accessDenied: "Adgang nægtet",
  search: "Søg",
  year: "År",
  buttons: {
    loading: "Indlæser...",
    export: "Eksportér",
    delete: "Slet",
    save: "Gem",
    cancel: "Annuller",
    next: "Næste",
    back: "Tilbage",
    skip: "Spring over",
    send: "Gem",
    clear: "Ryd",
    readNow: "læs nu",
    more: "Mere",
    close: "Luk",
    reportError: "Rapporter fejl",
    accept: "Acceptere",
    download: "Hent",
    downloadAll: "Download alle",
    dealerInfoDownload: "DOWNLOAD FORHANDLERINFORMATION",
    toTheBasket: "Til kurven",
    toOrderDelivery: "Fortsæt til leveringsadressen",
    discover: "Udforsk",
    newAddress: "Opret ny leveringsadresse",
    selectAddressBtn: "Vælg leveringsadresse",
    toOrderSummary: "Til ordreoversigten",
    placeOrder: "Bindende ordre",
    toDashboard: "Til startsiden",
    newOrder: "Ny ordre",
    userOrders: "Til dine ordrer",
    toSearch: "SØG",
    select: "Vælg",
    moreCustomerNumbers: "+ TILFØJ FLERE KUNDENUMRE",
    pointsList: "Pointliste",
    clearFilters: "Fjern filter",
    selectAll: "Vælg alle",
    deselectAll: "Fjern valg",
    downloadSelection: "Download udvalg",
    setFilters: "Indstil venligst dit filter",
    loadMore: "Indlæs mere",
    toStaffDashboard: "Til dashboard",
    toQuiz: "TIL QUIZZEN",
    vouchers: "Værdibeviser",
    exchangeVoucher: "Indløs værdibeviskode",
    confirm: "Bekræft",
    sharePoints: "Del point",
    create: "Opret",
    update: "Opdater",
    toBDrive: "Til B-Drive",
    preview: "Forhåndsvisning",
    clickHere: "Se detaljer",
    all: "Alle",
  },
  tooltips: {
    info: "Har du brug for hjælp? +45 87 64 66 68",
  },
  confirmation: {
    header: "Bekræftelse krævet",
    message: "Vil du slette denne post?",
  },
  nav: {
    text_page: "Statisk side",
    consents: "Samtykker",
    dashboard: "Hjem",
    accountDashboard: "Hjem",
    account: "Min Profil",
    mailbox: "Indbakke",
    singleMailbox: "Beskeder",
    stammdaten: "Stamdata",
    news_feeds: "Nyheder",
    pointsOverview: "Pointoversigt",
    rewardsOverview: "Pointoversigt",
    about: "Om BS Plus",
    service_number: "Kontakt service",
    shop: "Belønningsbutik",
    salesPromotions: "Salgskampagner",
    promotions: "Min konto",
    shopCategory: "Belønningsshop",
    productDetails: "Produktdetaljer",
    userOrders: "Brugerordrer",
    shoppingCart: "Indkøbskurv",
    orderDelivery: "Leveringsadresse",
    orderSummary: "Ordreoversigt",
    brochure_prices: "Prislister, brochurer & SoMe",
    staff: "Service-dashboard",
    onlineTrainings: "Online træning",
    trainings: "Træninger",
    training: "Træning",
    trainingForm: "Træningsformular",
    staffVouchers: "Værdibeviser",
    wholesalerVouchers: "Værdibeviser",
    investment: "Investeringsstotte",
    media: "Medier",
    medias: "Medier",
    contact_service: "Kontaktoplysninger og service",
    productInfo: "PRODUKTINFORMATION",
    bDrive: "Produktbilleder",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Betingelser for deltagelse",
    first_stop: "Bridgestone dækgaranti",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Hjem",
    accountDashboard: "Hjem",
    account: "Min Profil",
    mailbox: "Indbakke",
    singleMailbox: "Beskeder",
    stammdaten: "Stamdata",
    news_feeds: "Nyheder",
    pointsOverview: "Pointoversigt",
    rewardsOverview: "Pointoversigt",
    about: "Om BS Plus",
    service_number: "Kontakt service",
    shop: "Belønningsbutik",
    salesPromotions: "Salgskampagner",
    promotions: "Min konto",
    shopCategory: "Belønningsshop",
    productDetails: "Produktdetaljer",
    userOrders: "Brugerordrer",
    shoppingCart: "Indkøbskurv",
    orderDelivery: "Leveringsadresse",
    orderSummary: "Ordreoversigt",
    brochure_prices: "Prislister, brochurer & SoMe",
    staff: "Service-dashboard",
    onlineTrainings: "Online træning",
    trainings: "Træninger",
    training: "Træning",
    trainingForm: "Træningsformular",
    staffVouchers: "Værdibeviser",
    wholesalerVouchers: "Værdibeviser",
    investment: "Investeringsstotte",
    media: "Medier",
    medias: "Medier",
    contact_service: "Kontaktoplysninger og service",
    productInfo: "PRODUKTINFORMATION",
    bDrive: "Produktbilleder",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Betingelser for deltagelse",
    first_stop: "Bridgestone dækgaranti",
    payouts: "Payouts",
},
  menu: {
    account: "Min Profil",
    plus: 'Om Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Salgsstøtte",
    mailbox: "Indbakke",
    about: "Om BS Plus",
    trainingAndCourses: "Uddannelse og kurser",
    externalTraining: "Ekstern træning",
    productInfo: "Produktinformation",
    productBrochures: "Produktbrochurer",
    priceLists: "Prislister",
    price: "Pris",
    complaintForm: "Klageformular",
    sales_support: "Salgsstøtte",
    contact_service: "Kontaktoplysninger og service",
    logOut: "Log ud",
    news: "Nyheder",
    news_feeds: "Nyheder",
    service_number: "Kontakt service",
    salesPromotions: "Salgskampagner",
    shop: "Butik",
    brochure_prices: "Prislister, brochurer & SoMe",
    onlineTrainings: "Online træning",
    trainings: "Træninger",
    media: "Medier",
    medias: "Medier",
    stammdaten: "Stamdata",
    preislisten: "Prislister",
  },
  validation: {
    requiredField: "Påkrævet felt",
  },
  sortBy: {
    default: "Sorter efter",
    desc: "Sorter efter: Nyeste",
    asc: "Sorter efter: Ældste",
    name: "Navn",
    date: "Dato",
    choiceBy: "Sortér",
  },
  month: {
    1: "januar",
    2: "februar",
    3: "marts",
    4: "april",
    5: "maj",
    6: "juni",
    7: "juli",
    8: "august",
    9: "september",
    10: "oktober",
    11: "november",
    12: "december",
  },
};


export default {
  messages,
};
